/* globals Routes */

Routes.configure({
  default_url_options: {
    locale: window.document.documentElement.lang,
  },
  url_links: true
});